export default __webpack_public_path__ + "static/media/piggy-bank.05d8c42e.svg";